export type DataMartErrorResponse = {
    errorMessage: string;
    errorType?: string;
    stackTrace?: string;
    statusCode: number;
    statusText: string;
};

export class DataMartError extends Error {
    response: DataMartErrorResponse;

    constructor(response: DataMartErrorResponse) {
        super();
        this.response = response;
    }
}
